<template>

  <div class="oa-box">
    <div>
      <div class="oa-title">{{oaApproveItems.modelName}} - {{oaApproveItems.approvalNo}}</div>
      <li v-for="i in oaApproveItems.fields" :key="i.fieldNo" style="padding-top:3px">
        <span style="width:100px;display:inline-block">{{i.fieldName}}: </span>
        <span>{{dealFieldValue(i)}}</span>
      </li>
    </div>

    <div style="padding-top:0.4rem" v-if="file.length!=0">
      <div class="oa-title">附件</div>
      <li v-for="i in file" :key="i.resourcesId" style="margin-bottom:7px">
        <span class="down" @click="downf(i)">{{getFileName(i)}}</span>
      </li>
    </div>

    <div class="oa-links-box">
      <div class="oa-title">流程</div>
      <li class="oa-links">
        <img style="width: 40px; height: 40px; margin-right: 8px" src="@/assets/default.png" />
        <div class="cont">
          <div>发起申请</div>
          <div>{{ oaApproveItems.initiator.staffName }}</div>
        </div>
        <div>{{dealFormatDate(oaApproveItems.initiator.createDate)}}</div>
      </li>

      <div v-for="links in oaApproveItems.links" :key="links.parentId">
        <div class="oa-arrow" style="margin-top:4px;margin-bottom:4px" v-if="links.members.length!=0"></div>

        <li v-for="i in links.members" :key="i.memberId" class="oa-link-li">
          <div class="oa-links">
            <img style="width: 40px; height: 40px; margin-right: 8px" src="@/assets/default.png" />
            <div class="cont">
              <div>
                <span v-if="links.userType === 'approver'">
                  <span v-if="oaApproveItems.kitValue == 99">接收人</span>
                  <span v-else>审批人</span>
                </span>
                <span v-if="links.userType !== 'approver'">办理人</span>

                <span class="stus">{{getMembersStatus(i)}}</span>
              </div>
              <div style="padding:3px 0">{{ i.staffName }}</div>
              <div>{{ i.content }}</div>
            </div>
            <div>{{dealFormatDate(i.actionTime)}}</div>
          </div>

          <div class="oa-arrow"></div>
        </li>

      </div>
    </div>

    <div>
      <div class="oa-title">抄送人</div>
      <div class="oa-cpLink">
        <li v-for="i in oaApproveItems.copyLink.members" :key="i.memberId">
          <img style="width: 40px; height: 40px; margin-right: 8px" :src="i.avatar" />
          <span>{{i.staffName}}</span>
        </li>
      </div>
    </div>

  </div>

</template>

<script>
import dayjs from "dayjs";

export default {
  data() {
    return {
      visi: false,
      file: [],
      title: "",
    };
  },
  props: ["oaApproveItems", "oaVisi", "oaTitle"],
  watch: {
    oaTitle: {
      handler(newValue, oldValue) {
        this.title = newValue;
      },
    },
    oaVisi: {
      handler(newValue, oldValue) {
        this.visi = newValue;
        if (newValue == false) {
          this.close();
        }
      },
    },
    oaApproveItems: {
      handler(newValue, oldValue) {
        let data = newValue;
        let fields = data.fields;
        fields.map((item) => {
          if (item.fieldType == "upload") {
            this.file = item.value;
          }
        });
      },
      deep: true,
    },
  },
  mounted() {},
  methods: {
    close() {
      this.file = [];
    },
    // 值特殊处理
    dealFieldValue(i) {
      if (!i.fieldValue || i.fieldValue == "null") {
        return "";
      }

      // 地图点
      if (i.fieldType == "map") {
        let text = "";
        let obj = JSON.parse(i.fieldValue);
        text = obj.name + "(" + obj.address + ")";
        return text;
      }

      // 同行人
      if (i.fieldType == "dept") {
        let text = "";
        let arr = JSON.parse(i.fieldValue);
        arr.map((item) => {
          text += item.name + ", ";
        });
        let l = text.length;
        text = text.substring(0, l - 2);
        return text;
      }

      //   附件
      if (i.fieldType == "upload") {
        let text = "";
        let arr = i.value;

        arr.map((item) => {
          text += item.name + item.suffix + ", ";
        });
        let l = text.length;
        text = text.substring(0, l - 2);
        return text;
      }

      return i.fieldValue;
    },
    // 处理时间
    dealFormatDate(val) {
      let text = "";
      text = dayjs(val).format("YYYY-MM-DD HH:mm:ss");
      return text;
    },
    // 处理审批人审批状态
    getMembersStatus(item) {
      let status = "";
      switch (item.status) {
        case "0":
          status = "审核中";
          break;
        case "1":
          status = "通过";
          break;
        case "2":
          status = "拒绝";
          break;
        case "3":
          status = "转交";
          break;
        case "4":
          status = "退回";
          break;
        case "5":
          status = "评论";
          break;
        case "7":
          status = "转交";
          break;
        default:
          break;
      }
      return status;
    },
    getFileName(i) {
      let text = "";
      text = i.name + i.suffix;
      return text;
    },
    downf(i) {
      window.open(i.url);
    },
  },
};
</script>

<style lang="less" scoped>
.oa-box {
  padding: 0.2rem;
}

.oa-links-box {
  padding: 0.4rem 0;
}

.oa-links {
  display: flex;

  .cont {
    width: 220px;
    margin-left: 10px;
    white-space: pre-wrap;
  }
}

.oa-arrow {
  width: 2px;
  height: 24px;
  background: #1484ff;
  margin: 2px 0 2px 18px;
}

.stus {
  margin-left: 14px;
  font-size: 12px;
}

.oa-title {
  padding-bottom: 7px;
}

.down {
  padding: 0 2px;
  color: #1484ff;
}

.down:hover {
  cursor: pointer;
}

.oa-link-li {
  list-style: none;
  margin-bottom: 7px;

  .oa-arrow {
    margin-top: -15px;
  }
}

.oa-link-li:last-of-type .oa-arrow {
  display: none;
}

.oa-cpLink {
  display: flex;
  flex-wrap: wrap;

  li {
    list-style: none;
    padding-right: 14px;
  }
}

li {
  list-style: none;
  white-space: pre-wrap;
}
</style>